import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    // Clear authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    
    // Redirect to login page
    navigate('/login');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActiveLink = (path) => {
    if (path === '/dashboard' && location.pathname === '/') return true;
    return location.pathname === path;
  };

  return (
    <nav className="bg-gradient-to-r from-emerald-500 to-teal-500 shadow-lg border-b border-emerald-600/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">          {/* Logo and Brand */}          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-3 group no-underline" onClick={closeMenu}>
              <div className="logo-container w-16 h-10 bg-white/10 backdrop-blur-sm rounded-lg p-1.5 group-hover:bg-white/20 transition-all duration-300">
                <img 
                  src="/assets/macroai-logo-2.png" 
                  alt="MacroAI Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-bold text-white hidden sm:block group-hover:text-emerald-100 transition-colors">
                Dashboard
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">            
            <Link
              to="/meals"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 no-underline ${
                isActiveLink('/meals')
                  ? 'bg-white/20 text-white shadow-sm'
                  : 'text-emerald-100 hover:bg-white/10 hover:text-white'
              }`}
            >
              <i className="bi bi-egg-fried text-lg"></i>
              <span>Meals</span>
            </Link>            <Link
              to="/settings"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 no-underline ${
                isActiveLink('/settings')
                  ? 'bg-white/20 text-white shadow-sm'
                  : 'text-emerald-100 hover:bg-white/10 hover:text-white'
              }`}
            >
              <i className="bi bi-gear text-lg"></i>
              <span>Settings</span>
            </Link>
            
            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="ml-4 px-4 py-2 bg-white/10 hover:bg-red-500/20 border border-white/20 hover:border-red-400/40 text-white rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 hover:shadow-md backdrop-blur-sm"
            >
              <i className="bi bi-box-arrow-right text-lg"></i>
              <span>Logout</span>
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-lg text-emerald-100 hover:text-white hover:bg-white/10 transition-all duration-200"
            >
              <i className={`bi ${isMenuOpen ? 'bi-x-lg' : 'bi-list'} text-xl`}></i>
            </button>
          </div>
        </div>        {/* Mobile Navigation Menu */}
        <div className={`mobile-menu md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? 'max-h-64 opacity-100 mobile-menu-enter' : 'max-h-0 opacity-0'
        } overflow-hidden`}>
          <div className="py-4 space-y-2 border-t border-white/10">            <Link
              to="/dashboard"
              onClick={closeMenu}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 no-underline ${
                isActiveLink('/dashboard')
                  ? 'bg-white/20 text-white shadow-sm'
                  : 'text-emerald-100 hover:bg-white/10 hover:text-white'
              }`}
            >
              <i className="bi bi-speedometer2 text-lg"></i>
              <span>Dashboard</span>
            </Link>            <Link
              to="/meals"
              onClick={closeMenu}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 no-underline ${
                isActiveLink('/meals')
                  ? 'bg-white/20 text-white shadow-sm'
                  : 'text-emerald-100 hover:bg-white/10 hover:text-white'
              }`}
            >
              <i className="bi bi-egg-fried text-lg"></i>
              <span>Meals</span>
            </Link>            <Link
              to="/settings"
              onClick={closeMenu}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 no-underline ${
                isActiveLink('/settings')
                  ? 'bg-white/20 text-white shadow-sm'
                  : 'text-emerald-100 hover:bg-white/10 hover:text-white'
              }`}
            >
              <i className="bi bi-gear text-lg"></i>
              <span>Settings</span>
            </Link>
            <button
              onClick={() => {
                closeMenu();
                handleLogout();
              }}
              className="w-full flex items-center space-x-3 px-4 py-3 bg-white/10 hover:bg-red-500/20 border border-white/20 hover:border-red-400/40 text-white rounded-lg text-sm font-medium transition-all duration-200 mt-4"
            >
              <i className="bi bi-box-arrow-right text-lg"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;